<template>
  <v-layout class="app-shell">
    <v-navigation-drawer permanent width="260">
      <div class="brand">Кабинет психолога</div>
      <v-list nav density="compact">
        <v-list-item prepend-icon="mdi-view-dashboard-outline" title="Обзор" to="/dashboard" />
        <v-list-item prepend-icon="mdi-image-multiple-outline" title="Медиаматериал" to="/catalogs" />
        <v-list-item prepend-icon="mdi-account-group-outline" title="Клиенты" to="/clients" />
        <v-list-item v-if="isAdmin" prepend-icon="mdi-account-cog-outline" title="Пользователи" to="/users" />
      </v-list>
      <template #append>
        <v-btn class="ma-4" block variant="tonal" prepend-icon="mdi-logout" @click="signOut">Выйти</v-btn>
      </template>
    </v-navigation-drawer>
    <v-main>
      <div class="page-wrap">
        <slot />
      </div>
    </v-main>
  </v-layout>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { logout } from '../api/http';

const router = useRouter();
const currentUser = JSON.parse(localStorage.getItem('auth_user') || '{}');
const isAdmin = computed(() => currentUser.roles?.includes('admin'));

function signOut() {
  logout();
  router.push('/login');
}
</script>
